import type { ChatbotAiProvider, TenantAiKeysResponse } from '../types/chatbot.types';

export function hasTenantProviderKeyForCreate(
  provider: ChatbotAiProvider,
  botKeys: { openaiApiKey?: string; anthropicApiKey?: string },
  tenantKeys: TenantAiKeysResponse | null,
): boolean {
  switch (provider) {
    case 'openai':
      return Boolean(botKeys.openaiApiKey?.trim() || tenantKeys?.openaiApiKey.configured);
    case 'anthropic':
      return Boolean(botKeys.anthropicApiKey?.trim() || tenantKeys?.anthropicApiKey.configured);
    case 'openrouter':
      return Boolean(
        tenantKeys?.openrouterConfigured &&
          (tenantKeys.openrouterEnabledModels.length > 0 ||
            tenantKeys.openrouterCatalog.some(model => model.enabled)),
      );
    case 'local':
      return Boolean(
        tenantKeys?.localConfigured && tenantKeys.localLlmEnabledModels.length > 0,
      );
    default:
      return false;
  }
}

export function providerKeyCreateErrorMessage(provider: ChatbotAiProvider): string {
  switch (provider) {
    case 'anthropic':
      return 'Configure API Key Anthropic en el bot o en el tenant';
    case 'openrouter':
      return 'Configure OpenRouter en el tenant (API key y al menos un modelo habilitado)';
    case 'local':
      return 'Configure LLM local en el tenant (URL y al menos un modelo habilitado)';
    default:
      return 'Configure API Key OpenAI en el bot o en el tenant';
  }
}
